const Form028SC = {
    stepName: {
        ImportantNotes: "重要提示",
        ApplicationInfo: "教员注册资料",
        Confirmation: "确认",
    },
    label: {
        teacherInfo: "教员注册资料",
        schoolInfo: "学校资料",
        chineseName: "中文姓名",
        englishName: "英文姓名",
        title: "先生／女士",
        hkid: "身份证号码",
        permitNo: "教员注册证号码",
        schoolChop: "校印",
        // schoolName: "拟受僱学校名称",
        schoolName: "学校名称",
        schoolNumber: "学校编号",
        signature: "申请人签署",
        principal: "校监／校长签名",
        applicantName: "申请人姓名",
        supervisorName: "校监／校长姓名",
        contactNo: "申请人电话",
        approverEmailAddress: "申请人电邮地址",
        date: "日期",
        //dates: "日期",
        //edbDate: "日期",
        titleOption: {
            Mr: "先生",
            Ms: "女士",
        },
        teacherNoOption: {
            R: "检定教员编号",
            P: "准用教员编号",
            N: "不适用",
        },
        errTeacherNoR: "检定教员编号",
        errTeacherNoP: "准用教员编号",
        note: "填写申请表格须知",
        info1: "本人",
        info2: "（英文",
        info3: "）",
        info4: "，身份证号码：",
        info5: " 教员注册证号码：",
        info6: "（如适用）申请并授权教育局向下述学校的校监／校长发放有关本人的教员注册资料，包括贵局曾否拒绝本人检定／准用教员的注册申请、取消本人的检定／准用教员注册或曾否就本人的教师注册资格向本人发出谴责／警告／劝喻信等。",

        //FormB
        SchoolEmail: "学校电邮",
        fromSchoolSupervisorName: "校监／校长姓名",
        fromSchoolSchoolName: "学校名称",
        fromSchoolSchoolNumber: "学校编码",
        fromSchoolAddress: "学校地址",
        fromSchoolFaxNumber: "传真号码",
        statement: "我已阅读、理解并同意上述条款和条件。",
        termsConditions:
            "本人理解校监/校长及教师需要拥有「智方便+」帐户才能提交申请。",
    },

    edbNotes: {
        title: "由教育局职员填写",
        label1: "校监／校长：",
        label2: "根据本局的纪錄，就以上申请人的查询，现回复如下:",
        symbolStep: [
            { step: "(1)(i)" },
            { step: "(1)(ii)" },
            { step: "(1)(iii)" },
            { step: "(2)(i)" },
            { step: "(2)(ii)" },
            { step: "(2)(iii)" },
            { step: "(3)(i)" },
            { step: "(3)(ii)" },
            { step: "(4)" },
        ],
        option: {
            option1: "本局并无以上申请人的教师注册记录。",
            option2: "以上申请人现为检定教员。",
            option3:
                "以上申请人现为/曾为准用教员 。（ 如有关 准用教员停止受雇于其准用教员许可证上所指明的学校，该准用教员许可证将被视作无效。）",
            option4:
                "本局<u>没有</u>拒绝以上申请人的检定／准用教员注册申请或取消以上申请人的检定／准用教员注册的记录。",
            option5:
                "本局曾于_______年____月____日<u>拒绝</u>以上申请人的检定／准用教员注册申请。",
            option6:
                "本局曾于_______年____月____日<u>取消</u>以上申请人的检定／准用教员注册。",
            option7:
                "本局未有就以上申请人的教师注册资格向其发出谴责／警告／劝喻信 。",
            option8:
                "本局曾于_______年____月____日就教师注册资格向以上申请人发出*谴责／警告／劝喻信<sup> 须知(3)</sup>。",
            option9: "ˆ本局现正审视以上申请人的教师注册资格。",
        },
        label3: "学校处理应征者的个人资料时，应遵守《个人资料(私隐)条例》的规定 ， 以上资料亦只作处理职位申请及评估应征者是否适合该职位之用。如有进一步查询，请电 3467 8282 与教育局教师注册小组联络。",
        label4: "ˆ本局在完成审视教师的教师注册资格后 ，可能向其发出谴责／警告／劝喻信或取消其检定／准用教员注册。",
    },

    notes: {
        colon: [
            {
                text: "（1）",
            },
            {
                text: "（2）",
            },
            {
                text: "（3）",
            },
            {
                text: "（4）",
            },
        ],
        note: [
            {
                text: "教育局只会接受向学校发放注册资料的申请；至于向个人或其他机构发放注册资料的申请，将不予办理。",
            },
            {
                text: "学校在征得拟聘用教师的同意后，应向教育局申请将其教师注册资料向学校发放。申请表格可于教育局网页（<a href='http://edb.gov.hk', target='_blank'>www.edb.gov.hk</a>）下载 。",
            },
            {
                text: "如拟聘用教师根据《罪犯自新条例》（第297章）的第2（1）条可不披露其定罪，教育局并不会向学校披露本局就拟聘用教师有关定罪曾发出的谴责／警告／劝喻信的相关资料。",
            },
            {
                text: "申请人可邮寄、传真或亲身递交填妥的申请表至教育局 。收件地址如下：",
            },
        ],
        note3: [
            { text: "九龙协调道3号" },
            { text: "工业贸易大楼2楼" },
            { text: "教育局教师注册小组" },
            {
                text: "办公时间：星期一至五，上午八时三十分至下午一时， 下午二时至下午六时",
            },
            { text: "（星期六、 日及公众假期休息）］" },
            {
                text: "如有进一步查询，请与教师注册小组联络：",
            },
            {
                text: "电话：3467 8282",
            },
            {
                text: "传真：2520 0065",
            },
        ],
    },
    submittedDialog: {
        text1: "你已成功送出表格。请注意，表格尚未提交至教育局。现正等待教师填妥表格。",
        multiLayerSubmitMsg: "你将会转到填写表格的页面。",
    },
    approval: {
        noteCon1: "审视，并按提交表格以便输入资料",
        noteCon2: "审视，并按提交表格以便输入资料及签署",
    },
    errorMsg: {
        faxDigit: "传真号码必须为8位数",
    },
    // reply: "退回给学校",
};
export default Form028SC;
